import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

export interface SummaryItem {
  label: string;
  info: string;
  value: string | JSX.Element;
}

interface SummaryCardsProps {
  item: SummaryItem;
  index: number;
}

const SummeryCard: React.FC<SummaryCardsProps> = ({ item, index }) => {
  return (
    <Grid item xs={6} sm={true}>
      <Box
        sx={{
          width: "100%",
          height: 150,
          borderRadius: 4,
          overflow: "hidden",
          p: 2,
          background:
            index === 0
              ? "linear-gradient(45deg, #1c5284, #39e240, #e6e8ef)"
              : "linear-gradient(to bottom, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0.15) 100%), radial-gradient(at top center, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.40) 120%) #989898",
          backdropFilter: "blur(35px)",
          color: "#FFFFFF",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            position: "relative",
            zIndex: 1,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: [15, 25],
              fontWeight: 800,
            }}
          >
            {item.value}
          </Typography>
          <Typography
            sx={{
              fontSize: [12, 15],
              fontWeight: 500,
            }}
          >
            {item.label}
          </Typography>
          <Box sx={{ position: "absolute", top: -10, right: -10 }}>
            <Tooltip
              enterTouchDelay={0}
              followCursor
              placement="left-start"
              title={
                <Typography
                  variant="h6"
                  sx={{
                    width: 150,
                    fontSize: 12,
                    fontWeight: 600,
                    borderRadius: 1.5,
                    px: 1,
                  }}
                >
                  {item.info}
                </Typography>
              }
            >
              <IconButton>
                <InfoOutlinedIcon sx={{ color: "#FFFFFF" }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default SummeryCard;
